import CesiumGlobe from './CesiumGlobe';
import './index.css';
import Box from '@mui/material/Box/Box.js';
import CircularProgress from '@mui/material/CircularProgress';
import { useCatalogueContext } from './CatalogueContext';
import { Button, Paper, Typography } from '@mui/material';
import { useState } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import SideBar from './SideBar';



export default function Catalogue() {
  const {
    setIsModalProducts,
    setCatalogueModalOpen,
    isMapLoading,
    viewerRef,
    layersDisplayed,
    polygonsDisplayed,
    setPolygonsDisplayed,
    setLayersDisplayed,
    updatePayloadStatus,
  } = useCatalogueContext();
  const [areAllCollapsed, setAllCollapsed] = useState(true);
  const [isDragOver, setIsDragOver] = useState(false);

  const zoomToPolygon = (polygon: any) => {
    const { cesiumElement } = viewerRef.current;
    const { rectangle } = polygon;
    cesiumElement.camera.flyTo({
      destination: rectangle,
      duration: 2.0,
    });
    return;
  };


  const onDragEnd = (result: any) => {
    console.log(result);
    if (!result.destination) {
      return;
    }

    const newItems = Array.from(layersDisplayed);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);

    setLayersDisplayed(newItems);
  };

  const onRemoveAll = async () => {
    await viewerRef;
    const { cesiumElement } = viewerRef.current;
    console.log(cesiumElement.entities.removeAll());
    setPolygonsDisplayed([]);
    setLayersDisplayed([]);
  };

  const onChangeCollapse = () => {
    setAllCollapsed(!areAllCollapsed);
    for (let layerDisplayer of layersDisplayed) {
      setLayersDisplayed((prevLayers) => {
        const updatedLayers = prevLayers.map((layer) => {
          if (layer.id === layerDisplayer.id) {
            return { ...layer, isExpanded: !layer.isExpanded };
          }
          return layer;
        });
        return updatedLayers;
      });
    }
  };

  return (
    <Box sx={{ flexGrow: 1, width: '100%', height: '100vh' }}>
      <Grid container sx={{ height: '100%' }}>
        <Grid
          item
          xs={12}
          sm={3}
          md={2.5}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            borderRight: '1px solid',
            borderColor: 'divider',
            width: '100%',
          }}
        >
          <SideBar />
        </Grid>

        <Grid
          item
          xs={12}
          sm={9}
          md={9.5}
          sx={{ position: 'relative', height: '100%' }}
        >
          {isMapLoading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                bgcolor: 'rgba(255, 255, 255, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          )}
          <CesiumGlobe />
        </Grid>
      </Grid>
    </Box>
  );
}
